module.exports = __webpack_public_path__ + "img/DIMA_LOGO_PINK.png";